<template>
    <div class="professionals-services-search__footer">
        <div class="professionals-services-search__footer-title">Select one of the following</div>
        <div class="radio-button__group radio-button__group--row">
            <label class="radio-button" v-for="category in services.categories" :key="category.title">
                <input type="radio" v-model="filter" :value="category.title">
                <span class="radio-button__title">{{category.title}}</span>
            </label>
        </div>
    </div>
     <div class="professionals-services-search__form">
        <div class="news-block__cards-filter">
            <select v-for="category in services.categories" :key="category.title" v-show="filter === category.title" @change="handleChange">
                <option value="" disabled selected>Choose from below...</option>
                <template v-for="service in category.services" :key="service.title">
                    <option :value="service.url">{{ service.title }}</option>
                    <template v-for="child in service.children" :key="child.title">
                        <option :value="child.url">&nbsp;&nbsp;&nbsp;{{ child.title }}</option>
                        <option :value="child.url" v-for="child in child.children" :key="child.title">&nbsp;&nbsp;&nbsp;{{ child.title }}</option>
                    </template>
                </template>
            </select>
            <i class="icon-chevron-down"></i>
        </div>
    </div>
</template>

<script>
import ServicesService from '../../services/services';

export default {
    props: ["title"],
    components: {
     
    },
    data() {
        return {
            showAlpha: false,
            error: false,
            loading: true,
            services: [],
            activeCategory: null,
            activeService: null,
            activeChild: null,
            activeAlpha: null,
            filter: "Practices",
        }
    },
    mounted() {
        this.getServices();
    },
    computed: {
       
    },
    methods: {
        handleChange: function (e) { 
            window.location.href = e.target.value;
        },
        getServices: async function () {
            try {
                const services = await ServicesService.services();
                this.services = services;
                this.setActiveCategory(services.categories[0]);
                this.loading = false;
            } catch (error) {
                this.error = true;
                this.loading = false;
            }
        }
    }
}
</script>

